import { routes } from '../routes';
import reducer from './reducers'
import * as paypalOperations from './operation'

export {
    paypalOperations
}

export default {
    routes,
    reducer,
}